import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationStripeOnboardAccount({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({ clubId }: { clubId: number }) => {
      const response = await api.clubApi.stripeOnboardAccount(clubId);
      return response.data;
    },
  });
}
